import clsx from 'clsx';

import { ButtonProps } from '../../../types';
import styles from './styles.module.scss';

export function GenericButton({
  icon,
  size = 'medium',
  theme = 'main',
  variant = 'outlined',
  selected = false,
  children,
  className,
  ...buttonProps
}: ButtonProps): JSX.Element {
  const buttonStyles = clsx(
    styles.button,
    styles[theme],
    styles[variant],
    styles[size],
    { [styles.active]: selected },
    className,
  );

  const buttonIcon = <span className={styles.icon} aria-hidden>{icon?.src}</span>;

  return (
    <button
      type="button"
      className={buttonStyles}
      {...buttonProps}
    >
      {icon?.position === 'beginning' && buttonIcon}
      {children}
      {icon?.position === 'end' && buttonIcon}
    </button>
  );
}
